import { TMemo, TMemoItem } from '@/types/models.ts';
import { useAppTable } from '@/components/table/use-app-table.ts';
import { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { AppTable } from '@/components/table/app-table.tsx';
import { AppAssistanceButton } from '@/components/app/app-assistance-button.tsx';
import { Link } from '@tanstack/react-router';
import { routes } from '@/router/routes-urls.ts';

function ItemsCols(): ColumnDef<TMemoItem>[] {
  return [
    {
      header: '',
      id: 'img',
      cell: ({ row }) => (
        <div>
          <img className="w-10 h-10 object-cover" src={row.original.img_url} alt={row.original.name} />
        </div>
      ),
      size: 60,
    },
    { header: 'Barcode', accessorKey: 'barcode', size: 100},
    { header: 'Item Name', cell: ({row}) => (
      <div>
        <Link className="text-blue-500" to={routes.productView(row.original.product_id, row.original.color_id)} viewTransition={true}>
          {row.original.name}
        </Link>
      </div>
      ) },
    { header: 'Type', accessorKey: 'type', size: 150},
    { header: 'Status', accessorKey: 'status', size: 200 },
  ];
}

export function SampleMemoExpanded({ memo }: { memo: TMemo }) {
  const columns = useMemo(() => ItemsCols(), []);
  const at = useAppTable({
    data: memo.items,
    columns,
  });
  return (
    <div className="max-w-4xl mx-auto py-2">
      <div className="flex justify-between items-center mb-2">
        <div>
          {memo.signature && (
            <>
              <img className="max-h-24" src={memo.signature.img_url} alt={memo.signature.date} />
              <div>Signed on: {memo.signature.date}</div>
            </>
          )}
        </div>
        <AppAssistanceButton
          title="This Memo"
          message={`I need assistance with the samples for project ${memo.project.name}, memo id: ${memo.id}.`}
          subject={`Assistance with memo ${memo.project.name}`}
          btnText="NEED ASSISTANCE WITH THIS MEMO?"
        />
      </div>
      <AppTable at={at} />
    </div>
  );
}
